import { render, staticRenderFns } from "./OrgDropdowns.vue?vue&type=template&id=686a268c&"
import script from "./OrgDropdowns.vue?vue&type=script&lang=ts&"
export * from "./OrgDropdowns.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports